export default function getLocale(state) {
    const { locale } = state;

    if (!locale) {
        // TODO Align apps locale storage.
        return state.appState;
    }

    return locale;
}
